<template>
  <div style="position: absolute; width: 100%; height:100%;">
    子页面 {{ count }}
  </div>
</template>
<script>
  import router from "../../../router";
  export default {
    name: 'boxItem',
    data: () => ({
      count: 0,
    }),
    mounted() {
      document.addEventListener('keyup', this.keyup);
    },
    created() {

    },
    methods: {
      keyup(e) {
        if(e.keyCode == 37 || e.keyCode == 38){
          //上页 上箭头 左箭头
          console.log('上页itme:');
        }else if(e.keyCode == 39 || e.keyCode == 40){
          //下页 下箭头 右箭头
          console.log('下页itme:');
          this.count++;
          if(this.count >= 3){
            window.parent.postMessage('next', '*');
            this.count = 0;
          }
        }else if(e.keyCode == 32){
        }
      }
    },
    beforeDestroy() {
      document.removeEventListener('keyup', this.keyup);
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/box/board/item.vue